module.exports = __webpack_public_path__ + "img/popup-bg.2f3bb33c.webp";